import { StatusBar } from 'expo-status-bar';
import React from 'react';
import PropTypes from 'prop-types'
import ENV from 'app/utils/ENV'
import { StyleSheet, View, ScrollView, TouchableOpacity, ActivityIndicator, TouchableWithoutFeedback,
  Platform, TextInput, Dimensions, Alert, } from 'react-native';

import FilterBar from 'app/components/FilterBar'
import Text from 'app/components/Text'
import Value from 'app/components/Value'
import Timeline from 'app/components/Timeline'
import Draggable from 'app/components/Draggable'

import apiActions from 'app/utils/apiActions'
import valueActions from 'app/utils/valueActions'
import prefActions from 'app/utils/prefActions'
import storageActions from 'app/utils/storageActions'
import * as RootNavigation from 'app/utils/RootNavigation.js';
import textHelpers from 'app/utils/textHelpers'
import valueHelpers from 'app/utils/valueHelpers'
import ftueHelpers from 'app/utils/ftueHelpers'
import { styleSheet, colors, sizes, screenRatio, } from 'app/utils/styleSheet'

import { Hoverable } from 'react-native-web-hooks';

import { Ionicons, Octicons, FontAwesome, Feather, Entypo, MaterialCommunityIcons, } from '@expo/vector-icons';

export default class Workspace extends React.Component {
  
  static navigationOptions = ({ navigation, navigationOptions, screenProps}) => {
    return {
      headerShown: false,
    };
  };

  constructor(props) {
    super(props);

    let { navigation, route, } = this.props
    let value = !!route.params ? route.params.value : {}
    let id = !!route.params ? route.params.id : null

    this.state = {
      id,
      value: null,
      showTimeline: false,
      values: [],
      loading: true,
      fetching: false,
      query: '',
      hideComplete: true,
      showHidden: 0,
      fromBottom: true,
      showOnlyStarred: false,
      showNotes: true,
      showSnoozed: 0,
      showDoneToday: 1,
      familyIds: [],
      selectedValue: null,
      pendingSelectedValue: null,
      lines: [],
      quickActionsId: null,
      enableBlur: true,
      redrawKey: 0,
      consellationKey: 0,
      scrollHeight: Dimensions.get('window').height,
      scrollHeight: null,
      hiddenIds: [],
      filters: [],
      todoIds: [],
      focusIds: [],
      prefsLoaded: false,
      lastPressedId: null,
    }
  }

  setHeaderButton = () => {
    let { navigation, route, } = this.props
    navigation.setOptions({
      headerRight: () => (
        <TouchableOpacity onPress={navigation.toggleDrawer}>
          <Ionicons name="ios-menu" size={32} color={colors.foreground} style={{marginRight: 20}} />
        </TouchableOpacity>
      ),
    })
  }

  async componentDidMount(){
    this.setHeaderButton()

    let local = await storageActions.fetchItem('local', ENV.LOCAL)
    await this.setState({local})

    let pref = await prefActions.get()
    await this.setState({
      hiddenIds: pref.hidden_ids, 
      todoIds: pref.todo_ids, 
      focusIds: pref.focus_ids, 
      filters: pref.filters, 
      prefsLoaded: true,
    })

    // let values = await storageActions.fetchItem('values', [])
    // if(!!values?.length){
    //   values = valueHelpers.sortByTimeline(values)
    //   console.log(values.find(v => v.text == 'bake bread'))
    //   // values = valueHelpers.onlyRecentRevisions(values)
    //   await this.setState({values, value: values.find(v => v.id == 251)})
    //   this.setState({loading: false})
    // }
    // else {
    //   this.fetch()
    // }

    this.fetch()
    this._unsubscribe = this.props.navigation.addListener('focus', () => {
      this.fetch()
    });
    if(ENV.WEB && !!this.filterInput) this.filterInput.focus()

  }

  componentWillUnmount() {
    if(this._unsubscribe) this._unsubscribe();
  }

  fetch = async () => {
    let { id } = this.state
    if(!id) id = 251
    let value = await valueActions.get(id)
    console.log(value)
    this.setState({value, loading: false})
  }

  render(){
    let { navigation } = this.props
    let { values, fetching, query,
      hideComplete, showSnoozed, showOnlyStarred, showNotes, showDoneToday, showHidden, fromBottom,
      familyIds, selectedValue, lines, quickActionsId, enableBlur, redrawKey, scrollHeight,
      hiddenIds, focusIds, filters, prefsLoaded, loading,
      value,
    } = this.state

    let buttonColorOptions = [colors.trim, colors.active, colors.activeHighlight]
   

    return (
      <View style={styles.container} key={redrawKey}
        ref={ref => this.wrapperRef = ref}
        onLayout={({nativeEvent}) => {
          if (this.wrapperRef) {
            this.wrapperRef.measure((x, y, width, height, pageX, pageY) => {
              // console.log(`warpper: w:${width}, h:${height}, px:${pageX}, py:${pageY}`);
              this.setState({scrollHeight: height})
            })
          }
          else console.log(`no wrapper ref`)
        }}
      >
      {/*
      <View key={redrawKey} style={{flex: 1}}><ScrollView contentContainerStyle={styles.container}>
      */}
        <StatusBar style="auto" />

        {/*prefsLoaded && (
          <FilterBar
            ref={ref => this.filterBar = ref}
            loading={loading || fetching}
            filters={filters}
            hiddenIds={hiddenIds}
            focusIds={focusIds}
            onUpdate={() => this.setState({filterKey: (this.state.filterKey || 0)+1}) }
            onUpdateFilter={(filter, val) => {
              if(filter == 'showFocus'){
                this.setState({showFocus: val})
              }
            }}
            onFetch={this.fetch}
            hideQuery={!ENV.WEB}
          />
        )*/}

        <View style={{flex: 1}}>
          
          {/*!loading && this.renderLevels()*/}
          {!loading && this.renderValue(value)}

          <View style={styles.row}>
            <Draggable yThreshold={400} />

            <Draggable yThreshold={400}>
              <TouchableOpacity onPress={() => console.log('press?')}>
                <View style={{width: 80, height: 80, backgroundColor: 'red'}} />
              </TouchableOpacity>
            </Draggable>
            
            <Draggable yThreshold={400}>
              {!!value && <Value value={value} />}
            </Draggable>
          </View>

        </View>
        
        <View />
      </View>
    );
  }

  renderValue = value => {
    console.log(value)
    let { values, showTimeline, } = this.state
    return (
      <View style={{flex: 1, justifyContent: 'center', alignItems: 'center'}}>
        <Value 
          value={value} 
          size={200}
        />
        <Text onPress={() => this.setState({showTimeline: !showTimeline})} 
          style={{marginTop: sizes.giant}}
        >
          {showTimeline ? 'hide' : 'show'} timeline
        </Text>
        {showTimeline && (
          <Timeline value={value} allValues={values} />
        )}
        {/*
        */}
      </View>
    )
  }

}

let CIRCLE_RADIUS = 60;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'space-around',
    // backgroundColor: '#111',
  },
  row: {
    flexGrow: 1,
    borderColor: colors.trim,
    // borderBottomWidth: 1, 
    alignSelf: 'stretch',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-around',
    // padding: sizes.large,
    // borderColor:'white',borderWidth:1,
  },
  rowScroller: {
    flex: 1,
    alignSelf: 'stretch',
    flexDirection: 'row',
    flexWrap: 'nowrap',
  },
  rowScrollerContainer: {
    flexGrow: 1,
    flexDirection: 'row',
    justifyContent: 'center',
    // alignItems: 'center', 
    alignItems: 'stretch',
    // paddingTop: sizes.base,
    // flexWrap: 'wrap',
  },
  rowScrollerContent: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
  },
  valueWrapper: {
    flex: 1,
    alignSelf: 'stretch',
    // flexGrow: 0,
    justifyContent: 'center',
    alignItems: 'center',
    // borderColor: 'red', borderWidth: 2,
  },
  queryRow: {
    flexGrow: 0,
    height: 50,
    padding: sizes.base,
    justifyContent: 'flex-start',
  },
  input: {
    ...styleSheet.input,
    alignSelf: 'stretch',
    flex: 1,
  },
  icon: {
    marginLeft: sizes.base,
    minWidth: sizes.base,
    minHeight: sizes.base,
    // borderWidth: 1, borderColor: 'white',
  },
});